module.exports = __webpack_public_path__ + "img/icon_5_31.6e093abe.png";